import {CommonModule, isPlatformBrowser} from '@angular/common';
import {booleanAttribute, Component, computed, inject, Input, model, OnInit, PLATFORM_ID, Signal} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {$t, updatePreset, updateSurfacePalette} from '@primeng/themes';
import Aura from '@primeng/themes/aura';
import Lara from '@primeng/themes/lara';
import {PrimeNG} from 'primeng/config';
import {SelectButtonModule} from 'primeng/selectbutton';
import {LayoutService} from '@/layout/service/layout.service';
import {Router} from '@angular/router';
import {DrawerModule} from 'primeng/drawer';
import {ToggleSwitchModule} from 'primeng/toggleswitch';
import {RadioButtonModule} from 'primeng/radiobutton';
import { AppAuthService } from '@/services/app/auth.service';
import { TimeAgoPipe } from "../../pipes/time-ago.pipe";
import { AppNotification } from '@/models/notification.model';

@Component({
    selector: 'app-notifications',
    standalone: true,
    imports: [CommonModule, FormsModule, SelectButtonModule, DrawerModule, ToggleSwitchModule, RadioButtonModule, TimeAgoPipe],
    template: `
 <div class="flex align-items-center justify-content-between mb-3">
        <div class="text-900 font-medium text-xl">Notifications</div>
        <div>
            <button pButton pRipple (click)="openSettings()" icon="pi pi-cog" class="p-button-text p-button-plain p-button-rounded"></button>
            <button pButton pRipple (click)="clearAllNotifications()" icon="pi pi-trash" class="p-button-text p-button-plain p-button-rounded"></button>
        </div>
    </div>
    <ul *ngIf="showNotifications() else noNotifications" class="list-none p-0 m-0">
        <li *ngFor="let notification of notifications()" class="py-2 border-bottom-1 surface-border border-round-lg pt-2 px-3 pb-2 mb-3" style="background-color: var(--primary-lighter-color)">
        <div class="flex justify-content-between align-items-center mb-1">
                        <div class="flex align-items-center gap-1">
                            <h6 class="line-height-3 m-0 font-medium">{{ notification.summary}}</h6>
                            <span *ngIf="notification.actionType==='binder'" class="mt-1 text-400 block text-sm line-height-1">Binder {{notification.actionData}}</span>
                        </div>
    
                        <span class="text-gray-300 font-semibold text-sm line-height-1">{{ notification.dateCreated| timeAgo }}</span>
                    </div>
                    <div class="flex justify-content-between align-items-center">
                        <span class="mt-1 text-400 block text-sm line-height-1"> {{ notification.messageText }}</span>
                        <div>
                          <button type="button" pButton icon="pi pi-trash" (click)="clearNotification(notification)" class="p-button-rounded p-button-text p-button-sm flex-shrink-0" ></button>
                          <button type="button" pButton icon="pi pi-arrow-right" (click)="goto(notification)" class="p-button-rounded p-button-text p-button-sm flex-shrink-0" ></button>
                       
                        </div>
                       
                    </div>
        </li>
    </ul>

    <ng-template #noNotifications>
        <div class="text-center">No notifications...just crickets</div>
    </ng-template>
    `
})
export class AppNotifications {
    auth = inject(AppAuthService);
    notifications = computed(() => this.auth.userData()?.appNotifications?.filter(n => !n.isRead));

    openSettings() {
        // this.router.navigateByUrl('/user/settings');
      }
    
      navigateToBinder(binderId:number) {
        // this.binderService.navigate(binderId.toString());
      }

      clearNotification(notification: AppNotification) {
        // this.notificationsService.updateNotificationsAsRead();
      }
    
      clearAllNotifications() {
        // this.notificationsService.updateNotificationsAsRead();
      }

      goto(notification: AppNotification) {
        // this.router.navigateByUrl('/user/settings');
      }

      showNotifications() {
        const notifs = this.notifications();
        return notifs && notifs.length > 0;
      }
}
